import { PATH_SIGN_IN } from "@/constants";
import useAccount from "@/modules/account/hooks/useAccount";
import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

export default function AuthGuard({ children }: PropsWithChildren) {
  const { isSignedIn } = useAccount();

  if (!isSignedIn()) {
    return <Navigate to={PATH_SIGN_IN} replace />;
  }

  return children;
}
